"use client";

export function useInlineFeatureFlag<T>(_key: string, defaultValue: T): T {
  return defaultValue;
}
